/**
 * Status da cobrança que já vem aplicado ao abrir as telas que filtram por ele
 * (relatórios e dashboard financeiro).
 *
 * O recorte que o financeiro usa quase sempre é "só o que foi pago", e ele estava
 * escondido atrás de "Mais filtros": a cada aba, a cada troca de filial, a cada
 * recarga, o operador reabria o painel e marcava "Pago" de novo. Escolhido uma vez no
 * topo dos Relatórios, fica salvo no navegador e passa a ser o ponto de partida.
 *
 * **Preferência de quem opera, não configuração do sistema:** mora no `localStorage`,
 * por navegador, e não em `Setting`. Duas pessoas do mesmo financeiro podem querer
 * partidas diferentes, e ninguém precisa de permissão para escolher a própria.
 *
 * Mora em `lib/` porque é lido por telas de módulos diferentes — nasceu dentro de
 * Relatórios e o Dashboard Financeiro passou a compartilhar a mesma preferência.
 */
export const DEFAULT_BILLING_STATUS_KEY = 'reports:default-billing-status'

/** Sem padrão: a tela abre trazendo todos os status, como antes. */
export const NO_DEFAULT_BILLING_STATUS = ''

export function readDefaultBillingStatus(): string {
    try {
        return (
            localStorage.getItem(DEFAULT_BILLING_STATUS_KEY) ??
            NO_DEFAULT_BILLING_STATUS
        )
    } catch {
        // Navegador com armazenamento bloqueado (janela anônima, política de site):
        // a tela abre sem padrão em vez de quebrar.
        return NO_DEFAULT_BILLING_STATUS
    }
}

export function saveDefaultBillingStatus(value: string): void {
    try {
        if (value) localStorage.setItem(DEFAULT_BILLING_STATUS_KEY, value)
        else localStorage.removeItem(DEFAULT_BILLING_STATUS_KEY)
    } catch {
        // Sem persistência: a escolha vale para esta sessão e pronto.
    }
}

/**
 * O padrão no formato dos filtros que aceitam lista, ou `undefined` quando não há
 * padrão — e `undefined` é diferente de lista vazia: vazio é "nenhum status
 * escolhido", que o backend leria como recorte impossível.
 */
export function defaultBillingStatusFilter(value: string): string[] | undefined {
    return value ? [value] : undefined
}
